import type * as Icons from 'lucide-react';

export interface Prompt {
  promptName: string;
  prompt: {
    encoding: string;
    data: string;
  };
}

export interface Activity {
  id: string;
  title: string;
  description: string;
  prompts?: Prompt[];
}

export interface Workflow {
  id: string;
  title: string;
  description: string;
  icon: keyof typeof Icons;
  category: string;
  colorScheme: string;
  functionName: string;
  path: string;
  provider?: string;
  providerDisplayName?: string;
}

export interface WorkflowDetail extends Workflow {
  flowChart?: string;
  activities?: Activity[];
  function_name: string;
  inputSchema?: any;
  outputSchema?: any;
  provider?: string;
}

export interface WorkflowProvider {
  name: string;
  display_name: string;
  color_scheme: string;
}

export interface WorkflowRun {
  id: string;
  workflowId: string;
  status: number;
  startTime: string;
  endTime?: string;
  executionTime?: string;
  runId: string;
  name: string;
  provider?: string;
}

export type NavigationSection = 'description' | 'inputs' | 'activities' | 'run' | 'executions';

export interface NavigationItem {
  id: NavigationSection;
  label: string;
  icon: keyof typeof Icons;
}

export const navigationItems: NavigationItem[] = [
  { id: 'description', label: 'Description', icon: 'FileText' },
  { id: 'inputs', label: 'Inputs & Outputs', icon: 'Settings' },
  { id: 'activities', label: 'Activities', icon: 'Activity' },
  { id: 'run', label: 'Run..', icon: 'Play' },
  { id: 'executions', label: 'Executions', icon: 'History' },
];

export const colorMap = {
  blue: { bg: 'bg-blue-50', text: 'text-blue-600' },
  emerald: { bg: 'bg-emerald-50', text: 'text-emerald-600' },
  purple: { bg: 'bg-purple-50', text: 'text-purple-600' },
  orange: { bg: 'bg-orange-50', text: 'text-orange-600' },
  slate: { bg: 'bg-slate-50', text: 'text-slate-600' },
  indigo: { bg: 'bg-indigo-50', text: 'text-indigo-600' },
  zinc: { bg: 'bg-zinc-50', text: 'text-zinc-600' },
} as const;
